import React, { Component } from "react";
import "./home-container.css";
import aboutTC from "../images/about-tata-cliq.png";
import traningCenter from "../images/traning-center.png";
import whyChooseus from "../images/why-choose-us.png";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class HomeContainer extends Component {
  render() {
    return (
      <div className="main-container">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h1 className="text-center">Seller Experience Centre</h1>
              <p className="text-center">
                The CLiQ team aims to share knowledge with you. So CLiQ on each
                of these icons to jump into the sessions.
              </p>
            </div>
          </div>
        </div>
        <div className="container nav-block">
          <div className="row justify-content-md-center">
            <div className="col-sm-3">
              <Link to="/experiencezone/about" className="inner-link">
                <img src={aboutTC} alt="" className="main-icon" />
                About TATA CLiQ
              </Link>
              <ul>
                <li>- Integration process</li>
                <li>- What we Offer</li>
              </ul>
            </div>
            <div className="col-sm-3">
              <Link to="/experiencezone/traning-centre" className="inner-link">
                <img src={traningCenter} alt="" className="main-icon" />
                Training Centre
              </Link>
              <ul>
                <li>- Order Processing</li>
                <li>- Packaging Information</li>
                <li>- Customer Returns</li>
              </ul>
            </div>
            <div className="col-sm-3">
              <Link to="/experiencezone/why-choose-us" className="inner-link">
                <img src={whyChooseus} alt="" className="main-icon " />
                Why Choose TATA CLiQ
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HomeContainer;
